import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarComponent, SnackbarData } from '../components/snackbar-common/snackbar-common.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private snackBar = inject(MatSnackBar);

  /**
   * Shows a notification using the custom snackbar component
   * @param message The message to display
   * @param type The type of notification ('success' or 'error')
   * @param action Optional action button text (not used)
   * @param config Additional snackbar configuration
   */
  show(message: string, type: 'success' | 'error', action?: string, config: MatSnackBarConfig = {}): void {
    const duration = config.duration || 4000;
    
    const defaultConfig: MatSnackBarConfig = {
      duration,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['custom-snackbar-container', `snackbar-${type}`],
      ...config
    };

    this.snackBar.openFromComponent(SnackbarComponent, {
      ...defaultConfig,
      data: {
        message,
        type,
        duration
      }
    });
  }

  /**
   * Shows a success notification
   * @param message The success message
   * @param action Optional action button text (not used)
   * @param config Additional snackbar configuration
   */
  success(message: string, action?: string, config: MatSnackBarConfig = {}): void {
    this.show(message, 'success', action, config);
  }

  /**
   * Shows an error notification
   * @param message The error message
   * @param action Optional action button text (not used)
   * @param config Additional snackbar configuration
   */
  error(message: string, action?: string, config: MatSnackBarConfig = {}): void {
    this.show(message, 'error', action, config);
  }
}